import { useQuery } from "@tanstack/react-query";

import { marketplaceApi } from "@/features/marketplace/services/marketplace.api";
import type { SearchFilters } from "@/features/marketplace/types/search";

export function useSearchProducts(filters: SearchFilters) {
  return useQuery({
    queryKey: ["products", "search", filters],
    queryFn: () => marketplaceApi.searchProducts(filters),
  });
}
